/********************************************************************
 * Copyright (c) Certus Software, 2021.                             *
 *                                                                  *
 * This unpublished material is proprietary to Certus Software.     *
 * All rights reserved. The methods and techniques described        *
 * herein are considered confidential and/or trade secrets.         *
 * Reproduction or distribution, in whole or in part, is forbidden  *
 * except by express written permission of Certus Software.         *
 ********************************************************************/

import { Component, OnInit } from '@angular/core';
import {fadeInOutAnimation} from '../../_animations/animations';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {SpinnerServiceService} from '../../_services/spinner-service.service';
import {UtilsService} from '../../_services/utils.service';
import {Meta} from '@angular/platform-browser';

@Component({
  selector: 'app-http-errors',
  templateUrl: './http-errors.component.html',
  styleUrls: ['./http-errors.component.scss'],
  animations: [
    fadeInOutAnimation
  ]
})
export class HttpErrorsComponent implements OnInit {

  constructor(
    private spinner: SpinnerServiceService,
    public translate: TranslateService,
    private utilsService: UtilsService,
    private metaTagService: Meta
  ) { }

  ngOnInit(): void {
    this.metaTagService.removeTag('name = "robots"');
    this.metaTagService.addTag({
      name: 'robots',
      content: 'noindex, nofollow'
    });
    this.spinner.stop();
    this.utilsService.setTitleAndDescription('httpErrors.notAvailable', 'httpErrors.notAvailable');
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.utilsService.setTitleAndDescription('httpErrors.notAvailable', 'httpErrors.notAvailable');
    });
  }

  ngOnDestroy() {
    this.metaTagService.removeTag('name = "robots"');
    this.metaTagService.addTag({
      name: 'robots',
      content: 'index, follow'
    });
  }

}
